const Index = () => import(/* webpackChunkName: "collection" */ './index.vue');
const List = () => import(/* webpackChunkName: "collection" */ './components/List.vue');

export default [
  {
    path: 'collection',
    name: 'collection',
    component: Index,
    title: 'collection',
    redirect: { name: 'collection-list' },
    children: [
      
      {
        path: 'list',
        name: 'collection-list',
        component: List,
      },
      
    ],
  },
]
